import type { ReactNode } from "react";

type DialogTemplateProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export function DialogTemplate({
  children,
  className = "",
}: DialogTemplateProps) {
  return (
    <section
      aria-modal="true"
      className={`flex max-h-[calc(100vh-7.5rem)] max-w-[92vw] flex-col overflow-hidden rounded-dialog bg-surface shadow-dialog ${className}`}
      role="dialog"
    >
      {children}
    </section>
  );
}
